import { render, staticRenderFns } from "./ChatbotwithExp.vue?vue&type=template&id=381fb58c&"
import script from "./ChatbotwithExp.vue?vue&type=script&lang=js&"
export * from "./ChatbotwithExp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports